import PotmBadgesValue from "./PotmBadgesValue";

export default class PollBadgesValue extends PotmBadgesValue {}
